import React from 'react'

import { cn } from '@/lib/utils'

/**
 * The homepage shell used behind an auth card: the tinted panel fill with the exported blue
 * glow rising off the bottom edge (one cut per theme, drawn wider than the viewport so the
 * light shafts run off both sides).
 *
 * Fixed rather than absolute so the glow stays pinned to the foot of the viewport on cards
 * tall enough to scroll, instead of riding down with the content.
 */
const AuthBackdrop = ({ className }: { className?: string }) => (
  <div
    aria-hidden
    className={cn(
      "pointer-events-none fixed inset-x-[-10%] bottom-0 md:inset-x-[-80%] aspect-[1440/372] translate-y-[6%] bg-[length:100%_100%] bg-bottom bg-no-repeat bg-[url('/images/btm-gradient.png')] dark:bg-[url('/images/btm-gradient-dark.png')]",
      className
    )}
    style={{
      // A fixed 14px fade, matching the hero panel: the element's height tracks the
      // viewport width, so a percentage would grow into a visible wash on wide screens.
      maskImage: 'linear-gradient(to bottom, transparent 0px, #000 14px)',
      WebkitMaskImage: 'linear-gradient(to bottom, transparent 0px, #000 14px)',
    }}
  />
)

/** The ground the glow sits on — the same panel tint the guest-auth and onboarding cards use. */
export const AUTH_GROUND_CLASS = 'bg-[#F4F4F5] dark:bg-[#20232A]'

export default AuthBackdrop
